import LoadingComponent from 'Components/HelperComponents/LoadingComponent'
import { useAccreditacioEntities } from 'hooks/useAccreditacioEntities'
import { AccreditacioEntitySelector } from 'NewVersion/components/Accreditation/AccreditacioEntitySelector'
import 'NewVersion/styles/Acreditacions.scss'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { REGISTER_ENTITY_PATH, REGISTER_ENTITY_PERFORMING_FORM_PATH } from 'Routes/Paths'
import { ACCREDITATION_TYPE } from 'utils/constants'
import { getEntityRouteId } from './utils'

const PerformingSelectPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const {
    performing,
    accreditationCase,
    loading: loadingEntities,
    error,
  } = useAccreditacioEntities()

  useEffect(() => {
    if (!loadingEntities && !error && accreditationCase !== ACCREDITATION_TYPE.performing) {
      navigate(REGISTER_ENTITY_PATH, { replace: true })
    }
  }, [accreditationCase, error, loadingEntities, navigate])

  if (loadingEntities) {
    return <LoadingComponent />
  }

  if (error) {
    return (
      <div className="acreditacions page-wrapper">
        <h1>{t('acreditacions')}</h1>
        <p>
          {t('error_loading_accreditation', 'An error occurred loading your accreditation data')}
        </p>
      </div>
    )
  }

  if (accreditationCase !== ACCREDITATION_TYPE.performing) {
    return <LoadingComponent />
  }

  return (
    <div className="acreditacions page-wrapper">
      <AccreditacioEntitySelector
        entities={performing}
        onEntitySelected={(entity) => {
          navigate(
            REGISTER_ENTITY_PERFORMING_FORM_PATH.replace(':entityId', getEntityRouteId(entity))
          )
        }}
        onBack={() => {
          navigate(REGISTER_ENTITY_PATH)
        }}
        title={t('select_performing_entity', 'Select entity to accredit')}
      />
    </div>
  )
}

export default PerformingSelectPage
